var exports = {
  "ug": "ProTipContainer__xs0Vh5",
  "bL": "ProTip__LjE-q6",
  "cF": "ProTipCode__uPqzSa",
};

module.exports = exports;
